import Config from './config';
import { Dayjs } from 'dayjs'
import { loopDates } from './date';

const getSykesDeepLink = (propertyCode: string, start: Dayjs, nights: number): string => {
  const params: string[] = [
    `start=${start.format('YYYY-MM-DD')}`,
    `calendar=${start.format('YYYY-MM')}`,
    `duration=${nights}`,
  ];

  const sykes = Config.get('sykesPartnerId', []);

  return `https://www.sykescottages.co.uk/cottage/cottage-${propertyCode}.html?${sykes.join('&')}#${params.join('&')}`;
}
const getSupercontrolDeepLink = (propertyCode: string, start: Dayjs, nights: number): string => {
  const end = start.clone().add(nights, 'days');

  const dateString: string[] = []
  loopDates(start, end, 'day', (date: Dayjs) => {
    dateString.push(`${date.format('YYYY-MM-DD')}|${propertyCode}`)
  });

  const url = `https://secure.supercontrol.co.uk/availability/booking_insert.asp?ownerID=${Config.get('ownerId')}&siteID=${Config.get('siteId')}&cottageID=cottageID_${propertyCode}&numberpeople=0&children=0&infants=0&date_sb=${dateString.join(',')}`

  return url

}
const getVactionRentalsDeepLink = (propertyCode: string, start: Dayjs, nights: number): string => {
  const params: string[] = [
    `start=${start.format('DD-MM-YYYY')}`,
    `nights=${nights}`,
  ];

  const awaze = Config.get('awazePartnerId', []);
  const url = Config.get('awazeUrl', '');

  return url.replace(/{id}/, propertyCode) + '?' + params.concat(awaze).join('&');
}

export const getDeepLink = (start: Dayjs, nights: number): string => {
  const propertyCode = Config.get('propertyCode');
  const source = Config.get('source');

  if (Config.get('no-prices', false)) {
    return Config.get('no-price-url');
  }

  switch (source) {
    case 'sykes':
      return getSykesDeepLink(propertyCode, start, nights);
    case 'vacation-rentals':
      return getVactionRentalsDeepLink(propertyCode, start, nights);
    case 'supercontrol':
      return getSupercontrolDeepLink(propertyCode, start, nights);
    default:
      return '';
  }
}
